module.exports = __webpack_public_path__ + "assets/img/firstTime.f0f76b52.png";